import {
  __esm
} from "./chunk-ZU6LNBSF.mjs";

// src/utils/multi-ref.ts
var MultiRef;
var init_multi_ref = __esm({
  "src/utils/multi-ref.ts"() {
    MultiRef = class {
      constructor() {
        this.map = /* @__PURE__ */ new Map();
        this._refFns = /* @__PURE__ */ new Map();
      }
      ref(key) {
        let refFn = this._refFns.get(key);
        if (!refFn) {
          refFn = (value) => {
            if (value == null) {
              this._refFns.delete(key);
              this.map.delete(key);
            } else {
              this.map.set(key, value);
            }
          };
          this._refFns.set(key, refFn);
        }
        return refFn;
      }
    };
  }
});

export {
  MultiRef,
  init_multi_ref
};
